import React, { PureComponent } from 'react';
import { formShape } from 'rc-form';
import TextField from '../../SolvPatternLibrary/TextField';
import { emailInputValidator } from '../../../core/util/rcForm/validators';
import { EMAIL_ID } from './ids';

export default class EmailInput extends PureComponent {
  static propTypes = {
    form: formShape.isRequired,
  };

  state = { focused: false };

  get inputProps() {
    const { getFieldError, getFieldValue, getFieldProps } = this.props.form;
    const error = getFieldError(EMAIL_ID);
    const showErrors = !this.state.focused;

    return {
      ...getFieldProps(EMAIL_ID, {
        validateTrigger: ['onBlur', 'onChange'],
        onBlur: () => this.setState({ focused: false }),
        rules: [
          {
            required: true,
            validator: emailInputValidator,
          },
        ],
      }),
      id: EMAIL_ID,
      onFocus: () => this.setState({ focused: true }),
      value: getFieldValue(EMAIL_ID) || '',
      label: 'Email',
      error: showErrors && !!error,
      type: 'email',
      helperText: <span>{showErrors && Array.isArray(error) && error[0]}</span>,
    };
  }

  render = () => <TextField fullWidth {...this.inputProps} />;
}
